import React, {useState, useEffect,useContext} from "react";
import { useTranslate } from 'react-redux-multilingual';
import { ArticleFilterSearch2,ToastPopUp , ProfilActionButton, ExportArticleButton, ClearOutButton, ColumDataTableReorganize, ProfilParentRestockButton,DeleteActionButton,articleColumnGenerate,customFieldsColumnGenerate,priceSuppColumnGenerate,tauxTvaColumnGenerate,enumereColumnGenerate,articleEditionDatatable,articleDataGenerator,AddMarkExportForm,CardPerso,useLocalStorage,articlePriceUnitSuppDataGenerator} from "@gull";
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type} from 'react-bootstrap-table2-editor';
import axios from 'axios'
import { useCookies} from 'react-cookie';
import { articleHardData } from 'app/articleHardData';
import swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { IsAuthContext } from 'app/App';
import {scrollXDataTable} from 'app/scrollXDataTable';
import {articleListErp} from 'app/columnsArticleListeDataTable'

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columnShow.length)
    }, [window.screen.width,props.columnShow.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            bootstrap4
            remote
            pagination={ paginationFactory(props.paginationOptions) }
            onTableChange={ props.handleTableChange }
            noDataIndication={t('tableNoData')}
            defaultSortDirection={props.defaultSortDirection}
            cellEdit={ cellEditFactory({ 
                mode: 'dbclick', 
                blurToSave: true,
            }) }
            hover
            condensed
            responsive
        />
    );
};

const PersonalizedPriceItemList = (props) => {
    const t = useTranslate();
    const tableName = "basePersonalizedPriceItemList" 
    const { id } = useParams();
    const [filtre,setFiltre] = useState({})
    const [perPage,setPerPage] = useState(50)
    const [currentPage,setCurrentPage] = useState(1)
    const [localStorage, setLocalStorage] = useLocalStorage(['personalized_prices_fields','personalized_price_item_list_reorganize']);

    const [lang, setLang] = useCookies(['lang']);
    const [showModalCustomFiltre, setShowModalCustomFiltre] = useState(false);
    const [validButton,setValidButton]=useState(false)
    const { authParam } = useContext(IsAuthContext);
    const moduleErp = authParam.modules.find(value=>value.name=='erp')
    const [toast,setToast]=useState(false) 
    const [addMark,setAddMark]=useState(true) 

    const [showAccordion,setShowAccordion]=useState(false) 
    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false)

    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    let cookieLecture = ['internalid','name','reference','price','action'];
    if(localStorage.personalized_prices_fields){
        let columnShowVar = localStorage.personalized_prices_fields;
        cookieLecture = columnShowVar.split(',')
    }
    const [columnShow,setColumnShow] = useState(cookieLecture)
    const [clearTable,setClearTable]=useState(false)

    //partie qui concerne l'export et permet d'exporter le tableau dans l'ordre dans lequel il est affiché 
    const [headerColumnShowExport,setHeaderColumnShowExport]=useState('') 
    useEffect(function () {
        let headerColumnShowExportArr = [] 
        
        columnOrganize.map(value=>{
            if(columnShow.includes(value.dataField)) headerColumnShowExportArr.push(value.dataField)
        })
        setHeaderColumnShowExport(headerColumnShowExportArr.join(',').replace('action,',''))
    }, [columnShow,columnOrganize])
    //End

    const deleteItemOfList = async (itemId) =>{
        const response = await axios.delete(process.env.REACT_APP_API_URL+"api/erp/personalized_price/delete_article/"+props.personalizedPriceId+'/'+itemId
        ).then((response) => {
            let newData = props.articles.filter(value=>value.id!=itemId)
            props.setArticles(newData)
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError
            if(error.response==undefined){
                messageError='unknowError'
            }else if(error.response.status==403){
                messageError='forbiddenGeneral'
            }else {
                messageError='unknowError'
            }
            swal.fire(t(messageError), "", "error");
        })
    }

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
                setPerPage(page)
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );
   
    let paginationOptions = {
        page:currentPage,
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: props.sizeDatas
    };

    let datas = new Array
    props.articles.forEach((value,ind)=>{
        let obj = {
            masque:'',
            id: value.id,
            action: 
                <span className="d-flex justify-content-between">
                    <ProfilActionButton  path={'/erp/article/edit/'+value.id} openWindow={true}/> 
                    {(value.parent_name!=null && value.parent_name!='') ? <ProfilParentRestockButton optionModule={moduleErp} value={value} path={'/erp/automatic-restock/parent-item/'+value.id}/>  : false}
                    <DeleteActionButton deleteFunctionArgument={value.id} actionType={'typeDeleteX'} nameType={'delete'} toDelete={value.name} customClickEvent={deleteItemOfList}/>
                </span>,
            index: ind + 1,
        }
        articleDataGenerator(obj,value,t)
        articlePriceUnitSuppDataGenerator(obj,value,props.suppPrice)
        for (let i=0; i<props.maxConditionnement; i++){
            let numeroEnumere = i+1
            obj['name_'+numeroEnumere]= (value.hasOwnProperty('name_'+numeroEnumere) && value['name_'+numeroEnumere]!=null) ? value['name_'+numeroEnumere] : ''
            obj['reference_'+numeroEnumere]= (value.hasOwnProperty('reference_'+numeroEnumere) && value['reference_'+numeroEnumere]!=null) ? value['reference_'+numeroEnumere] : ''
            obj['quantity_'+numeroEnumere]= (value.hasOwnProperty('quantity_'+numeroEnumere) && value['quantity_'+numeroEnumere]!=null) ? value['quantity_'+numeroEnumere] : ''
        }
        props.suppPrice.map((item,index)=>{
            let numero = index+1
            let margePrixSupp = (value.hasOwnProperty('margeN_'+item['designation_'+numero]) && value['margeN_'+item['designation_'+numero]]!=null && value['margeN_'+item['designation_'+numero]]!=0) ? value['margeN_'+item['designation_'+numero]] : 0

            let margePercentPrixSupp = (value.hasOwnProperty('margeP_'+item['designation_'+numero]) && value['margeP_'+item['designation_'+numero]]!=null && value['margeP_'+item['designation_'+numero]]!=0) ? value['margeP_'+item['designation_'+numero]] : 0


            obj['price_'+item['designation_'+numero]]= (value.hasOwnProperty('price_'+item['designation_'+numero]) && value['price_'+item['designation_'+numero]]!==null && value['price_'+item['designation_'+numero]]!=='') ? value['price_'+item['designation_'+numero]] : ''

            obj['price_'+item['designation_'+numero]+'_ttc']= (value.hasOwnProperty('price_'+item['designation_'+numero]+'_ttc') && value['price_'+item['designation_'+numero]+'_ttc']!==null && value['price_'+item['designation_'+numero]+'_ttc']!=='') ? value['price_'+item['designation_'+numero]+'_ttc'] : ''

            obj['margeN_'+item['designation_'+numero]]= margePrixSupp

            obj['margeP_'+item['designation_'+numero]]= margePercentPrixSupp
        })
        props.categorieTva.map((categorie)=>{
            obj['taux_'+categorie.name]= (value.hasOwnProperty('taux_'+categorie.name) && value['taux_'+categorie.name]!=null) ? value['taux_'+categorie.name] : ''
        })
        props.customFields.forEach((item,index)=>{
            if(value.custom_fields){
                obj[item.name]=value.custom_fields[item.name]
            }
        })
        datas.push(obj)
    })

    const headerSortingStyle = { backgroundColor: '#c8e6c9' };

    let columnsInit = [
        {
            dataField: "action",
            text: "Actions",
            editable: false,
            headerClasses: 'head-action-row',
            classes: 'body-action-row',
        },
        {
            dataField: "internalid",
            text: t('internalId'),
            editable: false,
            sort: true,
            headerSortingStyle,
            hidden: (columnShow.includes("internalid")) ? false : true,
        },
    ];

    let columns=[
        ...columnsInit,
        ...articleColumnGenerate(articleListErp,columnShow,headerSortingStyle,articleEditionDatatable,props.optionsDataTable,props.ourOptionsDataTable,t,authParam),
        ...enumereColumnGenerate(props.maxConditionnement,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
        ...priceSuppColumnGenerate(props.suppPrice,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
        ...tauxTvaColumnGenerate(props.categorieTva,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam),
        ...customFieldsColumnGenerate(props.customFields,columnShow,headerSortingStyle,articleEditionDatatable,t,authParam)
    ]

    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.personalized_price_item_list_reorganize){
            let cookieLecture = localStorage.personalized_price_item_list_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{//on boucle sur toutes les colonnes existante sur le cookie de réorganisation 
                columns.map(item=>{//on vérifie dans l'array columns si les colonnes qu'il contient sont présent dans le cookie 
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle colonne à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    arrCol.push(item);
                }
            })
            columnCookie = arrCol

            if(arrCol.length !== cookieLecture.length){ 
                //Si des données articles ont été ajoutées ou si une configuration d'access à été faite pour rajouter ou retirer des colonnes, le cookie de réorganisation sera mis à jour 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage("personalized_price_item_list_reorganize",arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [])

    useEffect(function () {
        if(localStorage.personalized_prices_fields){
            let cookieColumnShow = localStorage.personalized_prices_fields.split(',')
            let columnsDatas = [] //contient toutes les dataFields de columns
            let arrColumnShow = [] //contient toutes les données sans doublons
            let arrColumnShowDoublon = [] //contient les doublons
            let arrColumnShowIntrus = [] // continent les fausse données

            columns.map(item=>{
                columnsDatas.push(item.dataField)
            })

            cookieColumnShow.map(value=>{
                //on vérifie si le cookie contien des doublons
                if(!arrColumnShow.includes(value)){
                    arrColumnShow.push(value)
                }else{
                    //Si value existe dejà c'est qu'il y a un doublon 
                    arrColumnShowDoublon.push(value)
                }
                //on vérifie si les données du cookies sont des données qui exisent dans le tableau columns
                if(!columnsDatas.includes(value)) arrColumnShowIntrus.push(value)
                
            })

            if(arrColumnShowDoublon.length!=0 || arrColumnShowIntrus.length!=0){ 
                //Si le cookie contient des doublons et des données qui n'existe pas en meme temps
                let uniformData = arrColumnShow.filter(value=> !arrColumnShowIntrus.includes(value))

                setLocalStorage("personalized_prices_fields",uniformData.join(),{ path: "/", expires: expire_date })
            }
        }
    }, [])

    const handleToggleColumns = (column,indexToEdit) => {
        if(column.toggle){
            var newColumnShow = columnShow.filter(value=>value!=column.dataField)

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = true

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
        }
        else{
            var newColumnShow = [...columnShow,column.dataField]

            //Modification pour la mise à jour des status hidden de chaque colonnes
            let dataColumn = columnOrganize.filter(value=>value.dataField!=column.dataField)
            let newData = column
            newData.hidden = false

            dataColumn.splice(indexToEdit,0, newData)

            setColumnOrganize(dataColumn)
            //End

            setColumnShow(newColumnShow)
        }
        setLocalStorage("personalized_prices_fields",newColumnShow.join(),{ path: "/", expires: expire_date }) 
    }
    
    const handleTableChange = async (type, { page, sizePerPage, sortField, sortOrder }) => {
        let objFiltre 

        if(type=='sort'){
            objFiltre = {
                ...filtre,
                sortField:sortField,
                sortOrder:sortOrder
            }
            setFiltre(objFiltre)
            props.setSendData({
                ...props.sendData,
                sortField:sortField,
                sortOrder:sortOrder
            })
        }else{
            objFiltre = filtre
        }

        setPerPage(sizePerPage)
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/erp/personalized_price/get_article_of_personalized_price/"+props.personalizedPriceId+"/"+sizePerPage+"/"+page,objFiltre
            ).then((response) => {
                props.setArticles(response.data.datas)
                props.setSizeDatas(response.data.count)
                setCurrentPage(page)
            }).catch((error) => {
                if(error=='end_session') return;
                swal.fire(t('unknowError'), "", "error");
            })
    }

    const handleSelect = (e,nameInput) => {
        props.setSendData({...props.sendData,[nameInput]:e.target.value})
    }

    const handleBool = (e,nameInput) => {
        props.setSendData({...props.sendData,[nameInput]:e.target.checked})
    }

    const CustomToggleAccordion = ({ children }) => {
        let hisClass = (showAccordion) ? "btn btn-sm btn-primary mb-3" : "btn btn-sm btn-outline-primary mb-3"
        
        return (
            <button
                type="button"
                className={hisClass}
                style={{marginRight:'10px'}}
                onClickCapture={()=>setShowAccordion(!showAccordion)}
            >
                {children}
            </button>
        );
    }

    const removeAllItems = async (promoId) =>{
        setValidButton(true)
        const callapi  = await axios.post(process.env.REACT_APP_API_URL+"api/erp/personalized_price/clean_article/"+promoId, {
        }).then((response) => {
            if(!response.data){
                let interms='';
                var keys = Object.keys(response.data.errors);
                for(var i = 0; i < keys.length; i++){
                    interms+=response.data.errors[keys[i]].join(',')+','
                }
                interms=interms.split(',')
                let messageError='';
                interms.forEach(interm=>messageError+=t(interm)+'<br/>')
                messageError=messageError.replace('undefined','');
                swal.fire(messageError);
            }
            else{
                setValidButton(false)
                props.setArticles([])
            }
        }).catch((error) => {
            if(error=='end_session') return;
            let messageError
            if(!error.response){
                messageError='unknowError'
            }
            else if(error.response.status===403){
                messageError='forbiddenGeneral'
            }
            else {
                messageError='unknowError'
            }
            swal.fire(messageError, "", "error");
        })
        setValidButton(false)
    }

    return (<>
        <ToastPopUp 
            showToast={toast}
            setShowToast={setToast}
            message={t('favoriteSaved')}
        />
        <CardPerso header={t('personalized_price')+' '+props.personalizedPrice.name}>
            {columnOrganize.length!=0 &&
                <small>
                    <ToolkitProvider
                    keyField="index"
                    data={ datas }
                    columns={ columnOrganize }
                    columnToggle
                    >
                    {(propst) => (
                        <>
                            <div className="row">
                                <div className="col-12 mb-2">
                                    <div className="row">
                                        <div className="d-flex align-items-baseline"> 
                                            <CustomToggleAccordion>{t('filtres')}</CustomToggleAccordion>
                                            <ColumDataTableReorganize 
                                                columnOrganize={columnOrganize}
                                                setColumnOrganize={setColumnOrganize}
                                                setCookie={setLocalStorage}
                                                cookieName='personalized_price_item_list_reorganize'
                                                { ...propst.columnToggleProps } 
                                                executWhenToggle={handleToggleColumns}
                                                showColumnOrganize={showColumnOrganize}
                                                setShowColumnOrganize={setShowColumnOrganize}
                                                btnSwitch={true}//pour affiche ou non le btn swith
                                                initSwith={false}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                            />&nbsp;&nbsp;&nbsp;
                                            <ExportArticleButton sizeDatas={props.sizeDatas} addMark={addMark} filtre={filtre} lang={lang.lang} header={headerColumnShowExport} title={t('exportSelectedColumnToCsv')} type="button" url={"api/erp/personalized_price/csvitem/"+props.personalizedPriceId}></ExportArticleButton>&nbsp;&nbsp;&nbsp;
                                            <AddMarkExportForm setAddMark={setAddMark} addMark={addMark} />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <span className="fs-4">
                                                {validButton ? 
                                                    <span><span>&nbsp;</span><div className="spinner-border spinner-border-sm"></div></span> 
                                                : 
                                                    <ClearOutButton title='btnRemoveAllItems' messageConfirm='removeAllArticlesConfirmPricePersonalized' customClickEvent={removeAllItems} deleteFunctionArgument={props.personalizedPriceId} />
                                                }
                                            </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <span className="alert alert-warning">
                                                {props.personalizedPrice.exclude_article=='0' ?
                                                    t('itemsWillBe')+' '+t('includedToPersonalizedPrice').toLowerCase()
                                                :
                                                    t('itemsWillBe')+' '+t('excludedToPersonalizedPrice').toLowerCase()
                                                }
                                            </span>
                                        </div>
                                    </div>
                                    {(showAccordion) &&
                                        <div className="row">
                                            <div className="col">
                                                <ArticleFilterSearch2
                                                    id={props.personalizedPriceId}
                                                    liaisons={props.liaisons}
                                                    customFields={props.customFields} 
                                                    setDataTable={props.setArticles} 
                                                    setSizeDatas={props.setSizeDatas} 
                                                    setFiltre={setFiltre} 
                                                    perPage={perPage}
                                                    customInterface={props.customInterface}
                                                    setCustomInterface={props.setCustomInterface}
                                                    setReload={props.setReload}
                                                    sendData={props.sendData}
                                                    setSendData={props.setSendData}
                                                    setShowModalCustomFiltre={setShowModalCustomFiltre}
                                                    showModalCustomFiltre={showModalCustomFiltre}
                                                    initAllFilter={{
                                                        archive:false,
                                                        stock:false,
                                                        havestock:"",
                                                        sortField:"",
                                                        sortOrder:""
                                                    }}
                                                    interface='filtreArticle' //Variable qui permet d'identifier l'url sur laquelle filtrer
                                                    hardData={articleHardData}
                                                    moduleName='filtrePersonalizedPrice'
                                                    setCurrentPage={setCurrentPage}
                                                    setClearTable={setClearTable}

                                                    tableName={tableName}
                                                    setToast={setToast}
                                                >
                                                    <div className="row">
                                                        {(moduleErp.params.stock.active) &&
                                                            <div className="col-lg-3 col-md-4 col-6">
                                                                <div className="form-group">
                                                                    <label className="col-form-label col-form-label-sm">{t('itemHaveStock')}</label>
                                                                    <select className="form-control form-control-sm" value={props.sendData.havestock} onChange={(e) => handleSelect(e,'havestock')}>
                                                                        <option value="">{t('itemLinkAndNotLinkToTock')}</option>
                                                                        <option value="oui">{t('itemLinkToTock')}</option>
                                                                        <option value="non">{t('itemNotLinkToTock')}</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        }
                                                        <div className="col-lg-3 col-md-4 col-6">
                                                            <div className="form-group mt-2">
                                                                <div className="col-12">
                                                                    <div className="form-check form-switch">
                                                                        <input type="checkbox" className="form-check-input"  checked={(props.sendData.archive) ? props.sendData.archive : false} onChange={(e) => handleBool(e,'archive')}/>
                                                                        <label className="form-check-label">{t('includeArchivetem')}</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </ArticleFilterSearch2>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                            {!clearTable &&
                                <div className="position-relative">
                                    <CustomDataTable 
                                        propst={propst}
                                        paginationOptions={paginationOptions}
                                        handleTableChange={handleTableChange}
                                        columnShow={columnShow}
                                        defaultSortDirection="asc"
                                    />
                                </div>
                            }
                        </>
                    )}
                    </ToolkitProvider>
                </small>
            }
        </CardPerso>
        </>
    );
}

export default PersonalizedPriceItemList;
